import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { Lademittel } from '../types/lademittel';
import {
  SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL,
  SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL_UEBERNEHMEN,
  SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL_ZUSWEISEN,
} from '../kommissionierung.api';
import { ArtikelMenge, MischPalette } from '@softapps/lager/core';
import { KommissionsauftragBewe } from '../types/kommissionsauftrag';

@Injectable({ providedIn: 'root' })
export class LademittelRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(id: string | number): Promise<Lademittel[]> {
    return (
      await this.#dataAccess.get<ResponseResult<Lademittel[]>>({
        path: SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL,
        pathParams: { id },
      })
    )?.result;
  }

  async createFromExistingOrderItem(
    item: KommissionsauftragBewe | null,
    id: string | number
  ): Promise<MischPalette> {
    return (
      await this.#dataAccess.create<Lademittel | {}, ResponseResult<MischPalette>>(
        {
          path: SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL_UEBERNEHMEN,
          pathParams: { id },
        },
        item ?? {}
      )
    )?.result;
  }

  async create(item: Lademittel | null, id: string | number): Promise<MischPalette> {
    return (
      await this.#dataAccess.create<Lademittel | {}, ResponseResult<MischPalette>>(
        {
          path: SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL,
          pathParams: { id },
        },
        item ?? {}
      )
    )?.result;
  }

  async assign(
    body: { bewegung: KommissionsauftragBewe; palette: any; menge: number },
    id: string | number
  ): Promise<KommissionsauftragBewe> {
    return (
      await this.#dataAccess.create<any, ResponseResult<KommissionsauftragBewe>>(
        {
          path: SOFTLINE_API_KOMMISSIONIERUNG_LADEMITTEL_ZUSWEISEN,
          pathParams: { id },
        },
        body
      )
    )?.result;
  }
}
